import { createClient } from '@supabase/supabase-js';

// Same Supabase project the POS + Admin use. Anon key is public-by-design;
// RLS scopes everything to the signed-in user's tenant. Customer ordering
// runs anonymously (no Saheeh login), so the anon role only sees rows that
// have a public-read policy (menu_items, categories) — orders go through
// a tenant-scoped insert path with the tenant ID derived from the QR/URL.
const SUPABASE_URL =
  import.meta.env.VITE_SUPABASE_URL ||
  'https://murxacfdulrkqinlubmz.supabase.co';

const SUPABASE_ANON_KEY =
  import.meta.env.VITE_SUPABASE_ANON_KEY ||
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im11cnhhY2ZkdWxya3Fpbmx1Ym16Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzg1MDE0NjUsImV4cCI6MjA5NDA3NzQ2NX0.8oPriepwpaq2xs-FYUdTOk9PG5Ry3eVmibYTPvSiw4A';

// Persist sessions so phone-OTP login survives page reloads.
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
    storageKey: 'saheeh-customer-auth',
  },
});

// Demo tenant — same `saheeh-test` tenant the POS demo lives in.
// In production this comes from a QR code, subdomain, or a tenant picker.
export const DEMO_TENANT_ID =
  (import.meta.env.VITE_DEFAULT_TENANT_ID as string | undefined) ||
  '2e31b6f2-d341-469d-b0a5-f3072a510c5f';
